import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_URL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PROD_BACKEND + "user/" : process.env.REACT_APP_DEV_BACKEND + "user/";

export const siteContentApi = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: API_URL,
        prepareHeaders: (headers) => {
            const user = JSON.parse(localStorage.getItem("user"));
            if (user && user.accessToken) {
                headers.set("authorization", user.accessToken);
            }
            return headers;
        },
    }),
    reducerPath: "siteContentApi",
    tagTypes: ["Home", "About"],
    endpoints: (build) => ({
        getHome: build.query({
            query: () => "all",
            providesTags: ["Home"],
        }),
        updateHome: build.mutation({
            query: ({ title, subtitle, paragraphs }) => ({
                url: "all",
                method: "PUT",
                body: { title, subtitle, paragraphs },
            }),
            invalidatesTags: ["Home"],
        }),
        getAbout: build.query({
            query: () => "about",
            providesTags: ["About"],
        }),
        updateAbout: build.mutation({
            query: ({ title, subtitle, educItems, researchItems, teachItems, langItems, certGroups }) => ({
                url: "about",
                method: "PUT",
                body: { title, subtitle, educItems, researchItems, teachItems, langItems, certGroups },
            }),
            invalidatesTags: ["About"],
        }),
    })
})

export const {
    useGetHomeQuery,
    useUpdateHomeMutation,
    useGetAboutQuery,
    useUpdateAboutMutation,
} = siteContentApi;
